import { Loading, User } from '@geovelo-frontends/commons';
import React, { ReactNode } from 'react';
import { Trans } from 'react-i18next';
import { Navigate } from 'react-router';

export function PrivateRoute({
  currentUser,
  defaultGuestPath,
  children,
  onRedirect,
}: {
  children?: ReactNode;
  currentUser: User | null | undefined;
  defaultGuestPath: string;
  onRedirect?: () => void;
}): React.JSX.Element {
  if (currentUser === undefined) return <Loading text={<Trans i18nKey="commons.user.loading" />} />;

  if (currentUser === null) {
    onRedirect?.();

    return <Navigate to={{ pathname: defaultGuestPath }} />;
  }

  return <>{children}</>;
}
